module.exports = "https://assets.bwbx.io/s3/reg2/images/favicon-dc3444013c05c8270b99.ico";